<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row>
            <v-btn rounded small class="ml-5" color="success" outlined @click="fnExcelReport('my-table-id', 'Stock Requests')"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
        </v-row>
        <v-card class="outer">
            <v-data-table :headers="headers" :items="all_stock_requests" id="my-table-id" class="elevation-1 mytable padding" :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>My Stock Dashboard</v-toolbar-title>                        
                        <v-divider class="mx-4 mr-10" inset vertical></v-divider>
                        <v-text-field class="" v-model="search" background-color="white" append-icon="mdi-magnify" label="Search" style="margin-left: 200px;"
                        single-line hide-details></v-text-field>
                        <v-col cols="12" sm="4" md="4" class="pl-0" align="end">
                            <v-btn class="mr-8" style="color: white;" small color="teal" @click="openRequestDialog">+ Request</v-btn>
                            <v-btn small style="color: white;" @click="viewRegister()" color="success">My Stock Register</v-btn>
                        </v-col>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row >
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="requestDialog" max-width="650px">
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="bg-color">
                                        <span>Stock Request</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12" class="pb-0">
                                                    <b>Item Category</b><v-icon class="pl-1 pb-2" small color="error">*</v-icon>
                                                    <v-autocomplete
                                                        dense
                                                        required
                                                        v-model="stock_item.itemCategory_id"
                                                        :items="item_category_list"
                                                        item-text="name"
                                                        :rules="[(v) => !!v || 'required']"
                                                        item-value="id"
                                                        @change="handleItemCategoryChange(stock_item.itemCategory_id)"
                                                        outlined
                                                        persistent-hint
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                                    <b>Item Name</b><v-icon class="pl-1 pb-2" small color="error">*</v-icon>
                                                    <v-autocomplete
                                                        dense
                                                        required
                                                        v-model="stock_item.item_id"
                                                        :items="filteredItems"
                                                        item-text="name"
                                                        :rules="[(v) => !!v || 'required']"
                                                        item-value="id"
                                                        outlined
                                                         @change="getSizeLableAndSizelableType(stock_item.item_id)"
                                                        persistent-hint
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                                    <b>Standard</b><v-icon class="pl-1 pb-2" small color="error">*</v-icon>
                                                    <v-autocomplete
                                                        dense
                                                        required
                                                        v-model="stock_item.standard_id"
                                                        :items="standard_list"
                                                        item-text="standard"
                                                        :rules="[(v) => !!v || 'required']"
                                                        item-value="id"
                                                        outlined
                                                        persistent-hint
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0" v-if="showSizeLabel">
                                                    <b>Size Label Type</b><v-icon class="pl-1 pb-2" small color="error">*</v-icon>
                                                    <v-autocomplete
                                                        dense
                                                        required
                                                        v-model="stock_item.sizeLabelType_id"
                                                        :items="size_label_type_list"
                                                        item-text="name"
                                                        :rules="[(v) => !!v || 'required']"
                                                        item-value="id"
                                                        outlined
                                                        readonly
                                                        filled
                                                        persistent-hint
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0" v-if="showSizeLabel">
                                                    <b>Size Label</b><v-icon class="pl-1 pb-2" small color="error">*</v-icon>
                                                    <v-autocomplete
                                                        dense
                                                        required
                                                        v-model="stock_item.sizeLabel_id"
                                                        :items="size_label_list"
                                                        item-text="name"
                                                        :rules="[(v) => !!v || 'required']"
                                                        item-value="id"
                                                        outlined
                                                        readonly
                                                        filled
                                                        persistent-hint
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                                    <b>Academic Year</b><v-icon class="pl-1 pb-2" small color="error">*</v-icon>
                                                    <v-autocomplete
                                                        dense
                                                        required
                                                        v-model="stock_item.ay_id"
                                                        :items="ay_list"
                                                        item-text="ay"
                                                        :rules="[(v) => !!v || 'required']"
                                                        item-value="id"
                                                        outlined
                                                        persistent-hint
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                                    <b>Quantity</b><v-icon class="pl-1 pb-2" small color="error">*</v-icon>
                                                    <v-text-field v-model="stock_item.request_quantity" persistent-hint type="number" min="0"
                                                    :rules="[(v) => v === 0 || !!v || 'required']"
                                                    outlined dense @input="updateRequestQuantity"
                                                        ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" class="pb-0 pt-0">
                                                    <b>Remark</b>
                                                    <v-textarea outlined v-model="stock_item.remark"
                                                        name="input-7-4"
                                                        
                                                    ></v-textarea>
                                                </v-col>                                               
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button79" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button78" @click="save" text :disabled="!valid"
                                            >Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
            </v-data-table>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data: () => ({
        valid: false,
        overlay: false,
        errorMsg: {
            name: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        headers: [
            {
                text: "Sr.No.",
                align: "left",
                sortable: false,
                value: "sr_no",
            },
            {
                text: "Item Category",
                align: "left",
                sortable: false,
                value: "item_category",
            },
            {
                text: "Item Name",
                align: "left",
                sortable: false,
                value: "item_name",
            },
            {
                text: "Size Label type",
                align: "left",
                sortable: false,
                value: "size_label_type",
            },
            {
                text: "Size Label",
                align: "left",
                sortable: true,
                value: "size_label",
            },
            {
                text: "Standard",
                align: "left",
                sortable: true,
                value: "standard",
            },
            {
                text: "Quantity",
                align: "left",
                sortable: true,
                value: "request_quantity",
            },
            { text: "Academic Year", value: "academicyear", sortable: false, align: "left" },
            { text: "Request Date", value: "request_date", sortable: false, align: "left" },
            { text: "Remark", value: "remark", sortable: false, align: "left" },
        ],
        stock_item: {
            itemCategory_id: null,
            standard_id:null,
            item_id:null,
            sizeLabelType_id:null,
            sizeLabel_id:null,
            ay_id:null,
        },
        requestDialog: false,
        size_label_list:[],
        size_label_type_list:[],
        item_category_list:[],
        itemList:[],
        standard_list:[],
        ay_list:[],
        showSizeLabel: false,
        all_stock_requests:[],
    }),

    computed: {
        // filteredStandards() {
        //     return this.standard_list.filter(item => item.standard !== "All" && item.standard !== "--");
        // },
        filteredItems() {
            return this.itemList.filter(item => item.name !== "All");
        }
    },
   
    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    mounted() {
        this.onLoad();
        this.getAllStockRequests();
    },
    methods: {
        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
            <tr>
            <th>Sr. No.</th>
            <th>Item Category</th>
            <th>Item Name</th>
            <th>Size Label Type</th>
            <th>Size Label</th>
            <th>Standard</th>
            <th>Quantity</th>
            <th>Academic Year</th>
            <th>Request Date</th>
            <th>Remark</th>
            </tr>`;

                this.all_stock_requests.forEach((s) => {
                    tab_text += `
            <tr>
                <td>${s.sr_no}</td>
                <td>${s.item_category}</td>
                <td>${s.item_name}</td>
                <td>${s.size_label_type}</td>
                <td>${s.size_label}</td>
                <td>${s.standard}</td>
                <td>${s.request_quantity}</td>
                <td>${s.academicyear}</td>
                <td>${s.request_date}</td>
                <td>${s.remark}</td>
            </tr>`;
                });

                tab_text += '</table>';

                const blob = new Blob([tab_text], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const filename = name + '.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
        },
        updateRequestQuantity(value) {
            // Parse the input value as a float, but preserve 0
            this.stock_item.request_quantity = value === '' ? null : parseFloat(value);
        },
        handleItemCategoryChange(itemCategoryId) {
            const selectedCategory = this.item_category_list.find(
                (category) => category.id === itemCategoryId
            );
            this.showSizeLabel = selectedCategory.is_size_applicable || false;
            this.getsizelable(itemCategoryId);
        },
        getsizelable(itemCategory_id) {
            this.itemList = [];
            const data = {

                itemCategory_id: itemCategory_id,
            };
            this.overlay = true;
            axios
                .post("/EduStore/getItemFromItemCategory", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.itemList = res.data.itemList;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    //  this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    // this.selected_date=""
                });
        },
        getSizeLableAndSizelableType(id) {

            const selecteditem = this.itemList.find((item) => item.id === id);

            if (selecteditem) {
                this.stock_item.sizeLabel_id = selecteditem.sizelabel_id;
                this.stock_item.sizeLabelType_id = selecteditem.sizeLabelType_id;
            } else {
                this.stock_item.sizeLabel_id = null;
                this.stock_item.sizeLabelType_id = null;
            }
            this.getStandardFromItem()
        },
        getStandardFromItem() {
            const data = {
                id: this.stock_item.item_id,
                
            };
            axios
                .post("/EduStore/getStandardFromItem", data)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                    
                            this.standard_list = res.data.standard_list;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.message);
                    } else {
                        this.showSnackbar("error", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("error", "Something went wrong...");
                    window.console.log(error);
                });
           
         },
        openRequestDialog(){
            this.requestDialog = true;
        },
        viewRegister() {
            let routeData = this.$router.resolve({ name: "my-stock-register" });
            window.open(routeData.href, "_blank");
        },
        save() {
            const data = {
                item_id: this.stock_item.item_id,
                request_quantity: this.stock_item.request_quantity,
                remark: this.stock_item.remark ? this.stock_item.remark : null, 
                ay_id:this.stock_item.ay_id, 
                itemCategory_id:this.stock_item.itemCategory_id,  
                sizeLabelType_id:this.stock_item.sizeLabelType_id ? this.stock_item.sizeLabelType_id : null, 
                sizeLabel_id:this.stock_item.sizeLabel_id ? this.stock_item.sizeLabel_id : null,  
                standard_id:this.stock_item.standard_id,               
                };
                axios
                    .post("/EduStore/saveStockRequest", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", res.data.message);
                            this.getAllStockRequests();
                            this.close();
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.message); 
                        } else {
                            this.showSnackbar("error", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("error", "Something went wrong...");
                        window.console.log(error);
                    });
                this.close();
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/EduStore/getStockRequestInitData")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.overlay = false;
                        this.size_label_list = res.data.size_label_list;
                        this.size_label_type_list = res.data.size_label_type_list;
                        this.item_category_list = res.data.item_category_list;
                    
                        this.ay_list = res.data.ay_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getAllStockRequests() {
            this.overlay = true;
            axios
                .post("/EduStore/getAllStockRequests")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        // this.showSnackbar("success", "SUCCESSS")
                        this.all_stock_requests = res.data.all_stock_requests;
                        this.overlay = false;
                        
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.requestDialog = false;
            this.stock_item.itemCategory_id = "",
            this.stock_item.ay_id = "",
            this.stock_item.item_id = "",
            this.stock_item.standard_id = "",
            this.stock_item.sizeLabel_id = "",
            this.stock_item.sizeLabelType_id = "",
            this.stock_item.request_quantity = "",
            this.stock_item.remark = ""
            // setTimeout(() => {
            //     this.editedItem = Object.assign({}, this.defaultItem);
            //     this.editedIndex = -1;
            // }, 300);
        },       
        isValidated() {
            if (this.editedItem.name) {
                return true;
            } else {
                if (!this.editedItem.name) {
                    this.errorMsg.name = true;
                }

                return false;
            }
        },

    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}
.bg-color {
    background-color: rgb(5, 196, 196);
    color: white;
}
.outer {
  background-color: white !important;
  margin: 8px !important;
  padding: 8px;
  border: 2px solid lightgray !important;

}

.button78 {
  background-color: rgb(5, 196, 196);
  border-radius: 12px;
  color: #000;
  cursor: pointer;
  font-weight: bold;
  padding: 10px 15px;
  text-align: center;
  transition: 200ms;
  color: white;
  box-sizing: border-box;
  border: 0;
  font-size: 16px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button78:not(:disabled):hover,
.button78:not(:disabled):focus {
  outline: 0;
  /* background: plum; */
  box-shadow: 0 0 0 2px rgba(0,0,0,.2), 0 3px 8px 0 rgba(0,0,0,.15);
}

.button78:disabled {
  filter: saturate(0.2) opacity(0.5);
  -webkit-filter: saturate(1) opacity(0.5);
  cursor: not-allowed;
  color: #fff !important;
}
.button79 {
  background-color: crimson;
  border-radius: 12px;
  color: #000;
  cursor: pointer;
  font-weight: bold;
  padding: 10px 15px;
  text-align: center;
  transition: 200ms;
  color: white;
  box-sizing: border-box;
  border: 0;
  font-size: 16px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button79:not(:disabled):hover,
.button79:not(:disabled):focus {
  outline: 0;
  /* background: lightgreen; */
  box-shadow: 0 0 0 2px rgba(0,0,0,.2), 0 3px 8px 0 rgba(0,0,0,.15);
}

.button79:disabled {
  filter: saturate(0.2) opacity(0.5);
  -webkit-filter: saturate(0.2) opacity(0.5);
  cursor: not-allowed;
}
.v-icon-size {
    font-size: 20px;
}
.padding tr{
    /* font-size: 18px !important; */
}
.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
